'use client'

import { FloatingWhatsApp } from 'react-floating-whatsapp'

interface WhatsappProps {
  whatsapp: string
  title?: string
  locale?: string
  statusMessage?: string
  chatMessage?: string
  avatar?: string
}

function Whatsapp({ whatsapp, title, locale , statusMessage , chatMessage , avatar}: WhatsappProps) {


  return (
      <FloatingWhatsApp
        className={locale === 'ar' ? 'rtl text-slate-900 whatsappChat' : 'ltr text-slate-900 whatsappChat' }
        // allowEsc={false}
        phoneNumber={whatsapp}
        accountName={title || 'Chat with us'}
        statusMessage={statusMessage ||  'Chat with us'}
        chatMessage={chatMessage || 'Hello, how can we help you?'}
        avatar={avatar || '/favicon.svg'}
        notification
        notificationSound
      />
  )
}

export default Whatsapp
